import React from "react";
import { Heading } from "../../components";
import { SectionBadge } from "./index";

function WhySection() {
    return (
        <section className="bg-black-900_02">
            {/* Use Tailwind classes only — inline style padding beats md: overrides in the CSS cascade */}
            <div className="flex flex-col gap-5 px-[200px] py-[120px] md:px-10 md:py-16 sm:px-5 sm:py-12">
                <SectionBadge>The Problem</SectionBadge>

                <Heading size="3xl" as="h2" className="mt-2" style={{ maxWidth: 820 }}>
                    <span className="text-gray-300">Today's AI has intelligence —&nbsp;</span>
                    <span className="text-transparent bg-gradient5 bg-clip-text">
                        but no relationship layer. AI can respond, but it cannot relate.
                    </span>
                </Heading>
            </div>
        </section>
    );
}

export default WhySection;
